// Pure helper split from usePushNotifications so unit tests can import it
// without dragging in Capacitor/Firebase modules.
//
// createdAtSeconds is preserved across refreshes: the backend idle check uses
// it as the "registered but never chatted" activity floor, so it must reflect
// first registration, not the latest app launch.
export function buildTokenRecord(existingRecord, platform, nowSeconds) {
  return {
    platform,
    createdAtSeconds: existingRecord?.createdAtSeconds ?? nowSeconds,
    updatedAtSeconds: nowSeconds,
  };
}
